<small>{{ barLabel }}</small>
<ul class="strength-bar" *ngFor="let x of style; let i = index">
  <li class="point" [style.background-color]="i <= strengthValue ? style[strengthValue].color : baseColor"></li>
</ul>
<small *ngIf="strengthValue >= 0" class="pre">{{ style[strengthValue].label | translate }}</small>
